import React  from 'react';
import './../../css/CardRedirection.css';
import {connect} from 'react-redux';
import {OnTriedAuthPageLoad,OnTryAuthCancel} from './../../components/SiteCat/SiteCat'
import {unProcessableEntity} from './../../constants/merchantData';

class CIDLockOutPage extends React.Component{
  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:""
    };
  }
  componentDidMount() {
    OnTriedAuthPageLoad(this.state.merchantName);
    const cancelUrlData = this.props.cidposts.cancelUrl ;
    this.setState({
      merchantName : this.props.cidposts.merchant,
      authCode : this.props.cidposts.authcode,
      cancelUrlData
    });
  }
  handleCancel = event => {
    OnTryAuthCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    unProcessableEntity(data);
  }
    render() {

        return(
        <React.Fragment>
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
              <div className="you-have-tried-to-auth">You’ve tried to authenticate your account too many times.</div>
              <div className="contact-us" x-ms-format-detection="none">We apologize for any inconvenience. Please contact us at
                                              <b> 1-800-347-2655</b> for immediate assistance and access to your account.</div>
              <div className="try-again-link"><button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button></div>
            </div>
          </div>
          </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
  return {
    cidposts: state
  }
}

export default connect(mapStateToProps)(CIDLockOutPage);
